import React, { useEffect, useState } from "react";
import "./resource.css";
import AddMore from "../../../assets/Icons/addMore.png";
import Remove from "../../../assets/Icons/minus.png";
import { DPR_API } from "../../../services/apiCalls/dprApiCalls";
import { toast } from "react-toastify";
import CreatableSelect from "react-select/creatable";
export default function Manpower(props) {
  const [role, setRole] = useState([]);
  const [roleType, setRoleType] = useState([]);
  const [colourOptions, setColorOption] = useState([]);
  const user = localStorage.getItem("state");
  const userInfo = JSON.parse(user);
  const [manPower, setManPower] = useState([
    {
      role: "",
      role_type: "",
      Resource_name: [],
      no_of_resources: "",
      TaskID: props.subId,
      ProjectID: props.project.project_id,
      WPID: 0,
      User_Id: userInfo?.user?.user_id,
    },
  ]);

  const addMoreMapnPower = (e) => {
    e.preventDefault();
    const user = localStorage.getItem("state");
    const userInfo = JSON.parse(user);
    setManPower([
      ...manPower,
      {
        role: "",
        role_type: "",
        Resource_name: "",
        no_of_resources: "",
        TaskID: props.subId,
        ProjectID: props.project.project_id,
        WPID: 0,
        User_Id: userInfo?.user?.user_id,
      },
    ]);
  };

  const RemoveMoreMapnPower = (index, e) => {
    e.preventDefault();
    const list = [...manPower];
    list.splice(index, 1);
    setManPower(list);
  };

  const getRole = async () => {
    const role = await DPR_API.get_Resource_role();
    if (role && role?.Role.length) {
      setRole(role.Role);
    } else {
      setRole([]);
    }
  };
  const getRoleType = async () => {
    const roleType = await DPR_API.get_Resource_role_type();
    if (roleType && roleType?.Role_type.length) {
      setRoleType(roleType.Role_type);
    } else {
      setRoleType([]);
    }
  };

  const selectChange = (index, e, type) => {
    const { name, value } = e.target;
    const list = [...manPower];
    list[index][name] = value;
    list[index]["TaskID"] = props.subId;
    setManPower(list);
  };
  const inputChange = (index, e, type) => {
    if (type == "Resource_name") {
      const list = [...manPower];
      list[index][type] = type === "Resource_name" ? e : e;
      list[index]["no_of_resources"] = e?.length;
      list[index]["TaskID"] = props.subId;
      setManPower(list);
    }
  };

  useEffect(() => {
    getRole();
    getRoleType();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    const UpdatedData = manPower.map((item) => {
      if (item.Resource_name) {
        return {
          ...item,
          Resource_name: item.Resource_name.map((resource) => resource.label),
        };
      }
      return item;
    });
    const createResource = await DPR_API.createResourceMapPower(UpdatedData);
    if (createResource && createResource.status === 201) {
      toast.success(createResource?.message, { autoClose: 2000 });
      setTimeout(() => {
        props.closeM(false);
      }, 2500);
    }
  };

  // const handleChange = (newValue, actionMeta) => {
  //   console.group("Value Changed");
  //   console.log("New Val", newValue);
  //   setColorOption(newValue);
  //   console.log(`action: ${actionMeta.action}`);
  //   console.groupEnd();
  // };

  return (
    <React.Fragment>
      {manPower?.map((val, x) => (
        <>
          <div className="row m-3">
            <div className="col-6">
              <label className="label-custom">Role</label>
              <select
                value={val?.role}
                name="role"
                onChange={(e) => selectChange(x, e, "role")}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value={""}>Select role</option>
                {role?.length
                  ? role.map((val) => (
                      <option value={val.role_id}>{val?.role_name}</option>
                    ))
                  : ""}
              </select>
            </div>
            <div className="col-6">
              <label className="label-custom">Role type</label>
              <select
                onChange={(e) => selectChange(x, e, "roleType")}
                name="role_type"
                value={val?.role_type}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option>Select role type</option>
                {roleType?.length
                  ? roleType.map((val) => (
                      <option value={val.roleType_id}>
                        {val?.roletype_name}
                      </option>
                    ))
                  : ""}
              </select>
            </div>
          </div>
          <div className="row m-3">
            <div className="col-12">
              <label className="label-custom">Resource Name</label>
              {/* <input
                onChange={(e) => inputChange(x, e, "resourceName")}
                name="Resource_name"
                value={val?.Resource_name}
                type="text"
                className="form-control shadow-none"
              /> */}
              <CreatableSelect
                isMulti
                onChange={(e) => inputChange(x, e, "Resource_name")}
                options={colourOptions}
              />
            </div>
            <div className="col-6">
              <label className="label-custom">Number of resources</label>
              <input
                disabled
                onChange={(e) => inputChange(x, e, "numberOfResources")}
                name="no_of_resources"
                value={val?.no_of_resources}
                type="text"
                className="form-control shadow-none"
              />
            </div>
          </div>
          <div className="row m-3">
            {manPower?.length !== 1 && (
              <div className="d-flex justify-content-end">
                <button
                  className="d-flex remove-more"
                  onClick={(e) => RemoveMoreMapnPower(x, e)}
                >
                  <div>
                    <img
                      src={Remove}
                      width={20}
                      height={20}
                      style={{
                        background: "red",
                        borderRadius: 40,
                        padding: 4,
                      }}
                    />
                  </div>
                  <div
                    className="my-auto"
                    style={{
                      color: "white",
                      fontSize: 14,
                      fontWeight: 500,
                      marginLeft: 2,
                    }}
                  >
                    Remove
                  </div>
                </button>
              </div>
            )}
          </div>
          <hr />
        </>
      ))}
      <div className="row m-3">
        <div className="d-flex justify-content-end">
          <button className="d-flex add-more" onClick={addMoreMapnPower}>
            <div>
              <img src={AddMore} width={20} height={20} />
            </div>
            <div
              className="my-auto"
              style={{
                color: "rgba(0, 0, 0, 1)",
                fontSize: 14,
                fontWeight: 500,
                marginLeft: 2,
              }}
            >
              Add More
            </div>
          </button>
        </div>
      </div>
      <div className="row mt-2">
        <div class="d-flex justify-content-center">
          <div style={{ margin: 10 }}>
            <button className="btn btn-primary" onClick={onSubmit}>
              Submit
            </button>
          </div>
          <div style={{ margin: 10 }}>
            <button className="btn btn-danger">Cancel</button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
